import { Button, Typography } from "@/design-system/Atoms";
import { usePatientCTAButtonConfig } from "@/hooks/usePatientCTAButtonConfig";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/routes/routes.config";

export const OralMedHeroContentSection = () => {
  const navigate = useNavigate();
   const { ctaButtonConfig, patientEntitlementsIsLoading } =
     usePatientCTAButtonConfig("Start Now");
  return (
    <section className="relative pb-[4.68rem] lg:pb-[10rem] pt-0 slider-offset-padding">
      <div className="w-full mx-auto box-border">
        <div className="flex flex-col xl:flex-row items-center gap-10">
          <div className="w-full !px-3 sm:px-6 xl:px-0 py-10 xl:py-0 lg:w-5/12">
            <Typography as="h1" className="mb-3" variant="sectionLargeTitle">
              Oral ED Medication
            </Typography>
            <Typography variant="sectionDescriptionLarge" as="p">
              Oral ED medications are a proven, convenient solution for managing
              erectile dysfunction. Taken as needed, they work quickly to
              enhance blood flow and help you regain confidence in your intimate
              moments.
            </Typography>
            <Button
              variant="secondary"
              size="xl"
              className={`mt-10 md:flex lg:flex 'btn-secondary' }`}
              onClick={() => {
                if (ctaButtonConfig.text === "View Products") {
                  navigate(`${ROUTES.PRODUCTS_BASE}/category/PDE5`);
                } else {
                  ctaButtonConfig.action();
                }
              }}
              loading={patientEntitlementsIsLoading}
            >
              {ctaButtonConfig.text}
            </Button>
          </div>
          <div className="relative w-full px-0 lg:ml-[8.333333%] lg:w-1/2 ">
            <img
              className="w-full object-cover align-middle"
              src="/images/oralmed/GettyImages-1197883803-1.png"
              alt="oral-med-head-content"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OralMedHeroContentSection;
